import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
var Status = /*#__PURE__*/ function() {
    "use strict";
    function Status(provider, status) {
        var message = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        _class_call_check(this, Status);
        this.provider = provider;
        this.status = status;
        this.message = message;
    }
    var _proto = Status.prototype;
    _proto.has = function has(provider) {
        return provider.prototype.constructor.name === this.provider.constructor.name;
    };
    _proto.getProvider = function getProvider() {
        return this.provider;
    };
    _proto.setProvider = function setProvider(provider) {
        this.provider = provider;
    };
    _proto.isStatus = function isStatus() {
        return this.status;
    };
    _proto.setStatus = function setStatus(status) {
        this.status = status;
    };
    _proto.getMessage = function getMessage() {
        return this.message;
    };
    _proto.setMessage = function setMessage(message) {
        this.message = message;
    };
    return Status;
}();
export default Status;
